const jQuery = require('jquery');
const _ = require('lodash');

const Mediator = require('./../../../core/mediator');
const Translator = require('./../../../core/translator');
const Loader = require('./../../../services/loader');

const zone = require('./../zone');
const sortMenuItems = require('./../../sortMenu');

let items = [];

const loadPromises = (promises) => {
   return jQuery.when.apply(undefined, promises).promise();
};

module.exports.init = (name, type) => {
   type = (typeof type === 'string') ? type : 'addLayer';
   let $panel = jQuery('<ul class="cloud-list list-unstyled"></ul>');
   let promises = [];
   let $item;

   Mediator.publish(`before:menu:${name}:ready`, promises);

   Loader.start($panel);
   loadPromises(promises).done(() => {
      items = [];

      Mediator.publish(`menu:${name}:ready`, items);

      items = sortMenuItems(items);

      _.forEach(items, function(item) {
         let itemClass = item.class ? item.class : '';
         $item = jQuery('<li><button class="btn btn-default btn-block '+ itemClass +'" data-name="'+ item.name +'">' + Translator.translate(item.name) + '</button></li>');
         $item.publish(`menu:${name}:${item.name}:click`);

         if (item.group) {
             $panel.append(jQuery(`<p>${Translator.translate(item.group)}</p>`));
         }

         $panel.append($item);
      });

      Mediator.publish(`after:menu:${name}:render`, {items, $panel});

      Loader.stop($panel);
   });

   zone[type](Translator.translate(name), $panel);
};
